import { render } from "./SpeechRequestItem.vue?vue&type=template&id=05190b7d&scoped=true"
import script from "./SpeechRequestItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SpeechRequestItem.vue?vue&type=script&charset=utf-8&lang=js"

import "./SpeechRequestItem.vue?vue&type=style&index=0&id=05190b7d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05190b7d"]])

export default __exports__